import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { device } from '../../styles/responsive';

const ScrollIndicatorContainer = styled(motion.div)`
  position: absolute;
  bottom: 40px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  z-index: 10;
  
  @media ${device.md} {
    bottom: 70px;
  }
  
  @media ${device.sm} {
    bottom: 60px;
  }
`;

const ScrollText = styled(motion.div)`
  font-size: 1rem;
  margin-top: 16px;
  opacity: 0.8;
  color: white;
  
  @media ${device.sm} {
    font-size: 0.9rem;
    margin-top: 12px;
  }
`;

const ScrollIcon = styled(motion.svg)`
  width: 22px;
  height: 34px;
  opacity: 0.8;
  
  @media ${device.sm} {
    width: 18px;
    height: 28px;
  }
`;

const ScrollDot = styled(motion.circle)`
  fill: currentColor;
`;

const ScrollIndicator = () => {
  return (
    <ScrollIndicatorContainer
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8, delay: 1.2, ease: "easeOut" }}
    >
      <ScrollIcon
        viewBox="0 0 28 44"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        animate={{ 
          y: [0, -8, 0]
        }}
        transition={{
          duration: 4,
          repeat: Infinity,
          ease: "easeInOut"
        }}
      >
        {/* Mouse outline */}
        <rect x="1" y="1" width="26" height="42" rx="13" />
        {/* Scroll wheel line */}
        <line x1="14" y1="8" x2="14" y2="16" />
        
        {/* Animated scroll lines */}
        <motion.line
          x1="14" y1="11"
          x2="14" y2="16"
          initial={{ opacity: 0.3, pathLength: 0 }}
          animate={{ 
            opacity: [0.3, 1, 0],
            pathLength: [0, 1],
            y: [0, 15]
          }}
          transition={{
            duration: 1.5,
            repeat: Infinity,
            ease: "easeIn",
            times: [0, 0.4, 1]
          }}
        />
        <motion.line
          x1="14" y1="11"
          x2="14" y2="16"
          initial={{ opacity: 0.3, pathLength: 0 }}
          animate={{ 
            opacity: [0.3, 1, 0],
            pathLength: [0, 1],
            y: [0, 15]
          }}
          transition={{
            duration: 1.5,
            repeat: Infinity,
            ease: "easeIn",
            delay: 0.2,
            times: [0, 0.4, 1]
          }}
        />
        <motion.line
          x1="14" y1="11"
          x2="14" y2="16"
          initial={{ opacity: 0.3, pathLength: 0 }}
          animate={{ 
            opacity: [0.3, 1, 0],
            pathLength: [0, 1],
            y: [0, 15]
          }}
          transition={{
            duration: 1.5,
            repeat: Infinity,
            ease: "easeIn",
            delay: 0.4,
            times: [0, 0.4, 1]
          }}
        />
      </ScrollIcon>
      <ScrollText>Scroll to Explore</ScrollText>
    </ScrollIndicatorContainer>
  );
};

export default ScrollIndicator; 